<template lang="pug">
  .container
    .item(
      v-for="n in 5"
      :key="n"
    )
      img(:src="placeholderSrc")
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import placeholderSrc from './images/placeholder.svg';

  export default defineNuxtComponent({
    name: 'ProfileCardPlaceholder',

    props: {
      count: {
        type: Number as PropType<number>,
        default: 5,
      },
    },

    computed: {
      placeholderSrc: () => placeholderSrc,
    },
  });
</script>

<style lang="scss" scoped>
  .item {
    position: relative;
    padding: 16px;

    @include big-tablet {
      padding: 24px;
    }

    &:after {
      position: absolute;
      content: '';
      height: 1px;
      background: $borderColor;
      left: 24px;
      bottom: 0;
      width: calc(100% - 48px);
      z-index: 1;
    }

    img {
      object-fit: none;
      object-position: left top;
      height: 100px;
      width: 100%;
    }
  }
</style>
